import { Building2 } from 'lucide-react';
import { useEnterpriseOrg } from '../../context/EnterpriseOrgContext';

type Props = {
  className?: string;
};

export function EnterpriseOrgSwitcher({ className }: Props) {
  const { activeOrgId, setActiveOrgId, orgMemberships } = useEnterpriseOrg();
  if (!orgMemberships.length) return null;

  return (
    <div className={className}>
      <label className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.12em] text-neutral-600">
        <Building2 className="h-3.5 w-3.5 text-violet-600" aria-hidden />
        Active enterprise org
      </label>
      <select
        value={activeOrgId || ''}
        onChange={(e) => setActiveOrgId(e.target.value || null)}
        className="mt-2 w-full rounded-md border border-violet-200 bg-white px-3 py-2 text-sm text-neutral-900"
      >
        {orgMemberships.map((m) => (
          <option key={m.organizations.id} value={m.organizations.id}>
            {m.organizations.name} ({m.role})
          </option>
        ))}
      </select>
    </div>
  );
}
